import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Formsy from 'formsy-react'
import { FormattedMessage, defineMessages } from 'react-intl'

import DiscountStatusBanner from '../DiscountStatusBanner/DiscountStatusBanner'
import Button from 'components/UI/Button/Button'
import FormInput from 'components/UI/FormInput/FormInput'

import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { fontSize } from 'themes/styles/dimensions'
import {
  Wrapper,
  Title,
  TextImageWrapper,
  Image,
  InfoSection,
  Info,
  Link,
  ButtonTextContainer,
  SmallPrint
} from './ReferralContent.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

const messages = defineMessages({
  teacherTitleMessage: {
    id: 'dashboard.referrals.teacherTitle',
    defaultMessage: 'Earn discounts for referring teachers'
  },
  teacherSubTitleMessage: {
    id: 'dashboard.referrals.teacherSubTitle',
    defaultMessage: 'Get 10% off for every friend or colleague that signs up'
  },
  parentTitleMessage: {
    id: 'dashboard.referrals.parentTitle',
    defaultMessage: 'Earn discounts for referring friends'
  },
  parentSubTitleMessage: {
    id: 'dashboard.referrals.parentSubTitle',
    defaultMessage: 'Get 10% off for every friend that signs up'
  },
  schoolTitleMessage: {
    id: 'dashboard.referrals.schoolTitle',
    defaultMessage: 'Share Night Zookeeper with teachers in other schools'
  },
  schoolSubTitleMessage: {
    id: 'dashboard.referrals.schoolSubTitle',
    defaultMessage: 'Give your friends 10% off Night Zookeeper'
  },
  shareLink: {
    id: 'dashboard.referrals.shareLink',
    defaultMessage: 'Copy and share your link'
  },
  smallinfoText: {
    id: 'dashboard.referrals.smallInfoText',
    defaultMessage:
      'Your friends will receive 10% off their Night Zookeeper subscription.'
  },
  submitEmails: {
    id: 'dashboard.referrals.submitEmails',
    defaultMessage: 'Or submit their emails below'
  },
  userExists: {
    id: 'dashboard.referrals.userExists',
    defaultMessage: 'One or more of these emails are already signed up! Why not refer someone else?'
  }
})

export default class ReferralContent extends Component {
  static propTypes = {
    parent: PropTypes.bool,
    subscriptionType: PropTypes.string,
    referralId: PropTypes.string,
    sendReferral: PropTypes.func,
    discountPercentage: PropTypes.number,
    isSubscribed: PropTypes.bool,
    teachers: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      emailExists: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit (emailString) {
    this.setState({ emailExists: false })
    const emailArray = emailString.email ? emailString.email.replace(/\s/g, '').split(',') : []
    emailArray.map(email => {
      this.props.freeEmail(this.props.client, email).then(result => {
        if (!result) this.setState({ emailExists: true })
      })
    })
    this.props.sendReferral(emailArray)
    this.refs.form.reset()
  }

  render () {
    const {
      parent,
      subscriptionType,
      referralId,
      sendReferral,
      discountPercentage,
      isSubscribed,
      teachers,
      screenWidth
    } = this.props

    const textImageStyle = !isSubscribed || teachers.length < 2 ? '60px' : '0'

    return (
      <Formsy onValidSubmit={this.handleSubmit} ref='form' >
        <GradientWrapper direction='darkRight'>
          <Wrapper>
            <Title type='main'>
              {parent ? (
                <FormattedMessage {...messages.parentTitleMessage} />
              ) : !isSubscribed || teachers.length === 1 ? (
                <FormattedMessage {...messages.teacherTitleMessage} />
              ) : (
                <FormattedMessage {...messages.schoolTitleMessage} />
              )}
            </Title>
            <TextImageWrapper textImageStyle={textImageStyle}>
              <Image />
              <InfoSection>
                <Title type='sub'>
                  {parent ? (
                    <FormattedMessage {...messages.parentSubTitleMessage} />
                  ) : !isSubscribed || teachers.length === 1 ? (
                    <FormattedMessage {...messages.teacherSubTitleMessage} />
                  ) : (
                    <FormattedMessage {...messages.schoolSubTitleMessage} />
                  )}
                </Title>
                <Info>
                  <FormattedMessage {...messages.shareLink} />
                </Info>
                <Link>{`www.nightzookeeper.com/edu/dashboard/register?referral=${referralId}`}</Link>
                <Info>
                  <FormattedMessage {...messages.submitEmails} />
                </Info>
                <FormInput
                  name='email'
                  width='100%'
                  value=''
                  placeholder='Enter email addresses separated by commas'
                  textSize={fontSize.milli}
                  validations={{
                    matchRegexp: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(,[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/
                  }}
                  validationErrors={{
                    matchRegexp: 'Please enter valid email addresses separated by commas'
                  }}
                  required
                />
                {this.state.emailExists
                  ? <SmallPrint type='smallRed'>
                    <FormattedMessage {...messages.userExists} />
                  </SmallPrint> : null}
                <ButtonTextContainer>
                  <SmallPrint type='smallBlue'>
                    <FormattedMessage {...messages.smallinfoText} />
                  </SmallPrint>
                  <Button element='button' bgColor={colors.blue} color={colors.white} size='small'>
                    Submit
                  </Button>
                </ButtonTextContainer>
              </InfoSection>
            </TextImageWrapper>
            {screenWidth > phoneMaxWidth ? (!isSubscribed || teachers.length < 2) && (
              <DiscountStatusBanner
                isSubscribed={isSubscribed}
                subscriptionType={subscriptionType}
                discountPercentage={discountPercentage}
              />
            ) : null}
          </Wrapper>
        </GradientWrapper>
      </Formsy>
    )
  }
}
